import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import VStack from '../../../../BaseModule/Components/VStack/Vstack';
import WizardChildren from '../../WizardChildren';

interface Props {
	item: Extract<
		WizardItem,
		{ type: WizardItemType.V_STACK | WizardItemType.CONTAINER }
	>;
	onSubmit: (values: any) => void;
}

const WizardVStack: React.FC<Props> = ({ item, onSubmit }) => {
	const settings = item.settings;
	const style: React.CSSProperties = {
		...(settings?.styleDesktop ?? settings?.style ?? {}),
		gap: settings?.gapDesktop ?? settings?.gap ?? '0px',
	};

	return (
		<VStack style={style}>
			{item.children.map(child => (
				<WizardChildren key={child.id} item={child} onSubmit={onSubmit} />
			))}
		</VStack>
	);
};

export default WizardVStack;
